<div>
  <app-top-menu></app-top-menu>
  <div class="container-fluid">
    <div class="row flex-nowrap">
      <div class="col-auto col-md-3 col-xl-2 px-sm-2 px-0 bg-dark">
        <div class="d-flex flex-column align-items-center align-items-sm-start text-white min-vh-100">
          <ul class="nav nav-pills flex-column mb-sm-auto align-items-center align-items-sm-start">
            <li class="nav-item">
              <a routerLink="/projects" class="nav-link align-middle px-0">
                <i class="fs-4 bi-house">P</i> <span class="ms-1 d-none d-sm-inline" translate>app.left.menu.projects</span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/attendees" translate>app.left.menu.attendees</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/alarms" translate>app.left.menu.alarms</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/timings" translate>app.left.menu.timings</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/reports" translate>app.left.menu.reports</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/notifications" translate>app.left.menu.notifications</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/settings" translate>app.left.menu.settings</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/help" translate>app.left.menu.help</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col py-3">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
